import { QUERY_KEYS } from 'api/query-keys';
import { partnerNotificationService } from 'partner/shared/services';
import { useQuery } from 'react-query';

export const useGetPartnerNotification = () => {
  const queryFn = async () => await partnerNotificationService.getPartnerNotifications();

  return useQuery(QUERY_KEYS.notifications(), queryFn);
};
